import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import { ContentZonesService, LocaleService, ConfigsModel } from '@sm360/widget-commons-core-services';
import { Translations as GeneralTranslations } from '@sm360/widget-commons-general';
import { Translations as FormTranslations } from '@sm360/widget-commons-forms';
import config from 'trade-in-360/config/index.js';

import OfficialTradeIn from 'trade-in-360/components/OfficialTradeIn/OfficialTradeIn.jsx';

import en from 'trade-in-360/i18n/en.json';
import fr from 'trade-in-360/i18n/fr.json';

class OfficialTradeInProvider extends Component {
    constructor(props) {
        super(props);

        merge(en, FormTranslations.en, GeneralTranslations.en);
        merge(fr, FormTranslations.fr, GeneralTranslations.fr);

        LocaleService.setLocale(props.locale);
        LocaleService.loadTranslations({ en, fr });

        this.configsModel = new ConfigsModel({
            organizationId: props.organizationId,
            organizationUnitId: props.organizationUnitId,
            organizationUnitLocation: props.organizationUnitLocation,
            websiteId: props.websiteId,
            location: props.location,
        });

        ContentZonesService.setImageServerBaseUrl(config.source.image);
        ContentZonesService.addContentZones(this.props.contentZones);
    }

    render() {
        return <OfficialTradeIn config={this.configsModel.getConfig()} />;
    }
}

OfficialTradeInProvider.displayName = 'OfficialTradeInProvider';

OfficialTradeInProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    websiteId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
};

export default OfficialTradeInProvider;
